import TagManager from 'react-gtm-module';

export const bannerClickEvent = (
    pageTitle = 'Strona główna',
    bannerType = 'Balk',
) => {
    const data = {
        dataLayer: {
            event: 'bannerClick',
            pageTitle,
            bannerType,
        },
    };

    return TagManager.dataLayer(data);
};

export const shopReferral = (shopName: string, shopLinkPlacement: string) => {
    const data = {
        dataLayer: {
            event: 'shopReferral',
            shopName,
            shopLinkPlacement,
        },
    };

    return TagManager.dataLayer(data);
};

export const partnerPageGA = (
    partnerButtonData: string,
    partnerName: string,
    partnerLink: string,
) => {
    let partnerButton;

    switch (partnerButtonData) {
        case 'Idź na zakupy':
            partnerButton = 'Przekierowanie do strony głównej partnera';
            break;
        case 'Załóż darmowe konto':
            partnerButton = 'Przekierowanie do rejestracji paypo';
            break;
        case 'Partner_business_card_category':
            partnerButton = 'Przekierowanie do strony głównej partnera';
            break;
        default:
            partnerButton = partnerButtonData;
    }

    const data = {
        dataLayer: {
            event: 'buttonClick',
            button: partnerButton,
            partner: partnerName,
            buttonLink: partnerLink,
        },
    };

    return TagManager.dataLayer(data);
};

export const formClickEvent = (formName: string, inputName: string) => {
    const data = {
        dataLayer: {
            event: 'formClick',
            formName,
            fieldName: inputName,
        },
    };

    return TagManager.dataLayer(data);
};

export const trackSearchTermEvent = (searchTerm: string) => {
    const data = {
        dataLayer: {
            event: 'view_search_contact',
            search_term_shops: searchTerm,
        },
    };

    return TagManager.dataLayer(data);
};

export const trackSearchTermShopEvent = (searchTerm: string) => {
    const data = {
        dataLayer: {
            event: 'view_search_shops',
            search_term_shops: searchTerm,
        },
    };

    return TagManager.dataLayer(data);
};

export const promoCodeCopyEvent = (promoCode: string) => {
    const data = {
        dataLayer: {
            event: 'copy_promo_code',
            promoCode,
        },
    };

    return TagManager.dataLayer(data);
};

export const pushBusinessFormStatusGTMEvent = (
    event: string,
    formName: string,
) => {
    const data = {
        dataLayer: {
            event,
            formName,
        },
    };

    return TagManager.dataLayer(data);
};

export const pushBusinessFormFirstStepFinishGTMEvent = () => {
    const data = {
        dataLayer: {
            event: 'nextStep',
            page: '/dane_biznesowe',
        },
    };

    return TagManager.dataLayer(data);
};

export const pushBusinessFormFieldFocusGTMEvent = (fieldName: string) => {
    const data = {
        dataLayer: {
            event: 'formClick',
            formName: 'Contact',
            fieldName,
        },
    };

    return TagManager.dataLayer(data);
};
